// PHASE 7: What emotion do you want to feel when you walk into your space?
import QuestionPage from '@app-studio-web/ui/pages/QuestionPage'
import { useTranslation } from 'react-i18next'
import { useSearchParams, useSubmit } from 'react-router-dom'
import useUpdateMode from '../../../hooks/useUpdateMode'
import { saveAnswer } from '../../../utils/onboardingStorage'

const QUESTION_KEY = 'emotionalGoal'

const OPTIONS = [
  {
    value: 'Calm and peaceful',
    translationKey: 'pages.onboarding.v2.emotionalGoal.options.calm',
    emoji: '😌',
  },
  {
    value: 'Energized and inspired',
    translationKey: 'pages.onboarding.v2.emotionalGoal.options.energized',
    emoji: '⚡',
  },
  {
    value: 'Proud and accomplished',
    translationKey: 'pages.onboarding.v2.emotionalGoal.options.proud',
    emoji: '🏅',
  },
  {
    value: 'Safe and cozy',
    translationKey: 'pages.onboarding.v2.emotionalGoal.options.safe',
    emoji: '🏠',
  },
  {
    value: 'Creative and free',
    translationKey: 'pages.onboarding.v2.emotionalGoal.options.creative',
    emoji: '🎨',
  },
  {
    value: 'Joyful and happy',
    translationKey: 'pages.onboarding.v2.emotionalGoal.options.joyful',
    emoji: '😊',
  },
]

export default function EmotionalGoalPage() {
  const submit = useSubmit()
  const { t } = useTranslation()
  const [searchParams] = useSearchParams()
  const value = searchParams.get('value')
  const preselectedValue =
    value && OPTIONS.some((option) => option.value === value)
      ? value
      : undefined
  const { isUpdate, postToReactNative } = useUpdateMode()

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    const formData = new FormData(event.currentTarget)
    const value = formData.get('answer') as string

    if (!value) return

    const answer = {
      question_key: QUESTION_KEY,
      question:
        'What emotion do you want to feel when you walk into your space?',
      answer_key: value,
      answer: value,
    }

    if (isUpdate) {
      postToReactNative(answer)
    } else {
      saveAnswer(QUESTION_KEY, answer)
      submit(event.currentTarget)
    }
  }

  const buttons = OPTIONS.map((option) => ({
    text: `${option.emoji} ${t(option.translationKey)}`,
    value: option.value,
  }))

  return (
    <QuestionPage
      heading={t('pages.onboarding.v2.emotionalGoal.heading')}
      buttons={buttons}
      onSubmit={handleSubmit}
      headingSize="text-3xl text-center whitespace-pre-line"
      buttonTextSize="text-xl"
      buttonBgColor="bg-white"
      preselectedValue={preselectedValue}
    />
  )
}
